import {
  useSelectedAppStoreScreens,
  useSelectedScreens,
} from "@/entities/selectedScreens";
import { useSelectedOnboardingScreens } from "@/entities/selectedScreens";
import { useSelectedSearchScreens } from "@/entities/selectedScreens";
import { useSelectedAnimationScreens } from "@/entities/selectedScreens";
import { SelectedScreenType } from "@/Views/Virtual/SelectedScreensPopup/SelectedScreensPopup";
import { useDispatch } from "react-redux";
import {
  selectedScreensActions,
  appStoreScreensActions,
  onboardingScreensActions,
  searchScreensActions,
  animationScreensActions,
} from "@/entities/selectedScreens";

interface UseSelectedScreensStatesProps {
  type: SelectedScreenType;
}

export const useSelectedScreensStates = (
  props: UseSelectedScreensStatesProps,
) => {
  const { type } = props;
  const dispatch = useDispatch();

  const { selectedScreens, clearSelectedScreens, removeScreen } =
    useSelectedScreens();

  const {
    selectedScreens: selectedAppStoreScreens,
    clearSelectedScreens: clearSelectedAppStoreScreens,
    removeScreen: removeAppStoreScreen,
  } = useSelectedAppStoreScreens();

  const {
    selectedScreens: selectedOnboardingScreens,
    clearSelectedScreens: clearSelectedOnboardingScreens,
    removeScreen: removeOnboardingScreen,
  } = useSelectedOnboardingScreens();

  const {
    selectedScreens: selectedSearchScreens,
    clearSelectedScreens: clearSelectedSearchScreens,
    removeScreen: removeSearchScreen,
  } = useSelectedSearchScreens();

  const {
    selectedScreens: selectedAnimationScreens,
    clearSelectedScreens: clearSelectedAnimationScreens,
    removeScreen: removeAnimationScreen,
  } = useSelectedAnimationScreens();

  const screens = (() => {
    switch (type) {
      case "appReplays":
        return selectedScreens;
      case "appStoreScreens":
        return selectedAppStoreScreens;
      case "onboardingScreens":
        return selectedOnboardingScreens;
      case "searchScreens":
        return selectedSearchScreens;
      case "animationScreens":
        return selectedAnimationScreens;
      default:
        return [];
    }
  })();

  const clearScreens = (() => {
    switch (type) {
      case "appReplays":
        return clearSelectedScreens;
      case "appStoreScreens":
        return clearSelectedAppStoreScreens;
      case "onboardingScreens":
        return clearSelectedOnboardingScreens;
      case "searchScreens":
        return clearSelectedSearchScreens;
      case "animationScreens":
        return clearSelectedAnimationScreens;
      default:
        return () => {};
    }
  })();

  const removeSelectedScreen = (() => {
    switch (type) {
      case "appReplays":
        return removeScreen;
      case "appStoreScreens":
        return removeAppStoreScreen;
      case "onboardingScreens":
        return removeOnboardingScreen;
      case "searchScreens":
        return removeSearchScreen;
      case "animationScreens":
        return removeAnimationScreen;
      default:
        return () => {};
    }
  })();

  // New function to update the saved flag for all screens
  const updateScreensSavedFlag = (isSaved: boolean) => {
    switch (type) {
      case "onboardingScreens":
        dispatch(onboardingScreensActions.updateAllScreensSavedStatus(isSaved));
        break;
      case "appReplays":
        dispatch(selectedScreensActions.updateAllScreensSavedStatus(isSaved));
        break;
      case "appStoreScreens":
        dispatch(appStoreScreensActions.updateAllScreensSavedStatus(isSaved));
        break;
      case "searchScreens":
        dispatch(searchScreensActions.updateAllScreensSavedStatus(isSaved));
        break;
      case "animationScreens":
        dispatch(animationScreensActions.updateAllScreensSavedStatus(isSaved));
        break;

      default:
        break;
    }
  };

  

  const updatePointIds = (
    savedPointIdsMap: Record<number, number>,
  ) => {
    switch (type) {
      case "onboardingScreens":
        dispatch(
          onboardingScreensActions.updateScreensSavedPointIds(savedPointIdsMap),
        );
        break;
      case "appReplays":
        dispatch(
          selectedScreensActions.updateScreensSavedPointIds(savedPointIdsMap),
        );
        break;
      case "appStoreScreens":
        dispatch(
          appStoreScreensActions.updateScreensSavedPointIds(savedPointIdsMap),
        );
        break;
      case "searchScreens":
        dispatch(
          searchScreensActions.updateScreensSavedPointIds(savedPointIdsMap),
        );
        break;
      case "animationScreens":
        dispatch(
          animationScreensActions.updateScreensSavedPointIds(savedPointIdsMap),
        );
        break;
      default:
        return () => {};
    }
  };
  return {
    screens,
    clearScreens,
    removeSelectedScreen,
    updateScreensSavedFlag,
    updatePointIds,
  };
};
